export default {
	user: JSON.parse(localStorage.getItem('user') ? localStorage.getItem('user') : null),
	token: localStorage.getItem('user-token'),
	checkingToken: true,
}
